<template>
  <div class="whole">
    <div class="title" style="font-size: 30px">板块楼盘地图查询</div>
    <div class="mr-right">
      <el-select
        v-model="area_name"
        filterable
        remote
        placeholder="搜索板块"
        :remote-method="handleSelectChangeLine"
      >
        <el-option
          v-for="item in select_area"
          :key="item.id"
          :label="item.area_name"
          :value="item.area_name"
        >
        </el-option>
      </el-select>
    </div>
    <el-button type="primary" @click="search()">查询</el-button>
  </div>
</template>
<script>
export default {
  name: "secondSubwaySale",
  data() {
    return {
      area_name: "",
      areas: [],
      select_area: [],
      area: {},
    };
  },
  async created() {
    await this.getAllAreas();
  },
  computed: {},
  methods: {
    async getAllAreas() {
      try {
        let res = await this.$axios.get(this.$url_prefix + "getallareas");
        this.areas = res.data.data;
        this.select_area = this.areas;
      } catch (error) {
        console.log(error);
      }
    },
    async handleSelectChangeLine(query) {
      this.select_area = this.areas.filter((item) => {
        return item.area_name.indexOf(query) !== -1;
      });
    },
    async search() {
      try {
        for (let index = 0; index < this.select_area.length; index++) {
          const element = this.select_area[index];
          if (element.area_name === this.area_name) {
            this.area = element;
            break;
          }
        }
        if (this.area.hasOwnProperty("id")) {
          console.log("选择板块", this.area.area_name);
          let item = {
            type: "单个板块地图",
            area: this.area,
          };
          this.$router.push({
            name: "location-image",
            params: item,
          });
        } else {
          this.$message.error("请选择板块");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
.whole {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
}
.table {
  margin-top: 4px;
  width: 100%;
}
.title {
  padding-bottom: 10px;
  font-weight: 700;
}
.mr-right {
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/page/secondHandArea.vue